import { Autocomplete } from '@mui/material';
import { useAtomValue } from 'jotai/index';
import { useCallback, useMemo } from 'react';
import { activeUsersAtom, usersByIdMapAtom } from '../../services/state/AppConfigStateJ';
import { IIdSelectorProps, popperSx, renderInput } from './commonSelectorDefs';

export const UserSelector = (props: IIdSelectorProps) => {
  const { getOptionDisabled, value, onChange, componentsProps, ...rest } = props;

  const usersById = useAtomValue(usersByIdMapAtom);
  const activeUsers = useAtomValue(activeUsersAtom);

  const userOptions = useMemo<number[]>(() => {
    return activeUsers.map((user) => user.id);
  }, [activeUsers]);

  const getOptionLabel = useCallback(
    (option: number) => {
      return usersById.get((option as number) ?? 0)?.name ?? '';
    },
    [usersById]
  );

  return (
    <Autocomplete
      openOnFocus
      options={userOptions}
      value={value ?? undefined}
      renderInput={renderInput}
      getOptionLabel={getOptionLabel as (option: unknown) => string}
      onChange={(e, newValue) => onChange(newValue as number | number[] | null)}
      getOptionDisabled={getOptionDisabled as (option: unknown) => boolean}
      componentsProps={{ popper: { sx: { ...popperSx } }, ...componentsProps }}
      {...rest}
    />
  );
};
